import createNamedWrapperReducer from '../common/reducers/createNamedWrapperReducer'
import itemReducerFn from '../common/reducers/itemsReducerFn'
import itemsReducerFn from '../common/reducers/itemsReducerFn'

export const reducerName = 'PRICE_RULE'
export const itemReducer = createNamedWrapperReducer({ reducerFunction: itemReducerFn, reducerName })
export const itemsReducer = createNamedWrapperReducer({ reducerFunction: itemsReducerFn, reducerName })